const menu = [
  {
    title: "Company",
    path: "/company",
  },
  {
    title: "Signup",
    path: "/register/:role",
  },
  {
    title: "Shop",
    path: "/shop",
  },
  { title: "Sell", path: "/sell" },
  {
    title: "PJ Index",
    path: "/paper-jumpsuit",
  },
  {
    title: "KleverBook™",
    path: "/kleverbooks",
  },
  {
    title: "Featured Publications",
    path: "/admin-book",
  },
  // {
  //   title: "KleverBooks",
  //   path: "/kleverbook",
  // },
];

export default menu;
